/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDOCUMENTTYPE } from './IAPDOCUMENTTYPE';
import {
    IAPDOCUMENTTYPEFromJSON,
    IAPDOCUMENTTYPEFromJSONTyped,
    IAPDOCUMENTTYPEToJSON,
} from './IAPDOCUMENTTYPE';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface UpdateProductDocumentViewModel
 */
export interface UpdateProductDocumentViewModel {
    /**
     * 
     * @type {IAPDOCUMENTTYPE}
     * @memberof UpdateProductDocumentViewModel
     */
    documentTypeId?: IAPDOCUMENTTYPE;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDocumentViewModel
     */
    documentName: string;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof UpdateProductDocumentViewModel
     */
    mimeTypeId?: IAPMIMETYPE;
    /**
     * 
     * @type {Date}
     * @memberof UpdateProductDocumentViewModel
     */
    contentManagerDateUploaded?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductDocumentViewModel
     */
    contentManagerFileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductDocumentViewModel
     */
    contentManagerItemId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductDocumentViewModel
     */
    isSelectedForSigning?: boolean;
}

/**
 * Check if a given object implements the UpdateProductDocumentViewModel interface.
 */
export function instanceOfUpdateProductDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "contentManagerItemId" in value;

    return isInstance;
}

export function UpdateProductDocumentViewModelFromJSON(json: any): UpdateProductDocumentViewModel {
    return UpdateProductDocumentViewModelFromJSONTyped(json, false);
}

export function UpdateProductDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProductDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentTypeId': !exists(json, 'DocumentTypeId') ? undefined : IAPDOCUMENTTYPEFromJSON(json['DocumentTypeId']),
        'documentName': json['DocumentName'],
        'mimeTypeId': !exists(json, 'MimeTypeId') ? undefined : IAPMIMETYPEFromJSON(json['MimeTypeId']),
        'contentManagerDateUploaded': !exists(json, 'ContentManagerDateUploaded') ? undefined : (new Date(json['ContentManagerDateUploaded'])),
        'contentManagerFileSize': !exists(json, 'ContentManagerFileSize') ? undefined : json['ContentManagerFileSize'],
        'contentManagerItemId': json['ContentManagerItemId'],
        'isSelectedForSigning': !exists(json, 'IsSelectedForSigning') ? undefined : json['IsSelectedForSigning'],
    };
}

export function UpdateProductDocumentViewModelToJSON(value?: UpdateProductDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'DocumentTypeId': IAPDOCUMENTTYPEToJSON(value.documentTypeId),
        'DocumentName': value.documentName,
        'MimeTypeId': IAPMIMETYPEToJSON(value.mimeTypeId),
        'ContentManagerDateUploaded': value.contentManagerDateUploaded === undefined ? undefined : (value.contentManagerDateUploaded.toISOString()),
        'ContentManagerFileSize': value.contentManagerFileSize,
        'ContentManagerItemId': value.contentManagerItemId,
        'IsSelectedForSigning': value.isSelectedForSigning,
    };
}

